import React, { Component } from "react";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";
import { fetchInitialData4, fetchInitialData3} from "../../fetchData";
import Right from '../../right/Right';
import Service from '../../service/Service';
import withContext from "../../../withContext";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useNavigate } from "react-router-dom";
import './growthtracker.css';
import './vaccination.css';
import Nonloggedin from './common/Nonloggedin.js';
import ChildListOverlay from './common/ChildListOverlay';
import FilterOverlay from './common/FilterOverlay.js';
import MarkDonePopup from './common/MarkDonePopup.js';
import ShowStatusPopup from './common/ShowStatusPopup.js';
import ShowVaccineDetailsPopup from './common/ShowVaccineDetailsPopup.js'
import FaqPopup from './common/FaqPopup';
import DisclaimerPopup from './common/DisclaimerPopup';
import FeedbackPopup from './common/FeedbackPopup';
import Swiper from "react-id-swiper";
import YouTube from "react-youtube";
import * as actions from "./Actions.js";

// import Slider from "react-slick";

const service = new Service();
class VaccinationTracker extends Component {
  constructor(props) {
    super(props);
    let initialData = {};
    // let isLoggedin = false;
    let isLoggedin = !!global.ftk && global.ftk.trim() !== "";
    let authData = '';
    let childdata=[];
    let vaccinationSummary=[];
    let minValues=[];
    let maxValues=[];
    let stages=[];
    let currentStage=[];
    let vccBanner_img_mob='';
    let vccBanner_img_desk='';
    this.dateRef = React.createRef();
    this.mainContainerRef = React.createRef();
    this.descriptionRefs = {};
    this.playersRef = {};
    this.ageSliderRef = React.createRef();
    this.ageSliderDivRef = React.createRef();
    
    let isApp = "";
    this.noMediaRef = React.createRef();

    const isDesktop = __isBrowser__
        ? window.innerWidth >= 768
        : global.isdesktop;

    if (global.ftk == '') {
        isLoggedin = false
    } else {
        isLoggedin = true
    }

    // Check app_ftk cookie if global.ftk is not available
    if (!isLoggedin && typeof document !== "undefined") {
        const cookieData = document.cookie || "";
        const cookieAry = cookieData.split(";");

        for (let i = 0; i < cookieAry.length; i++) {
            const cookie = cookieAry[i].trim();

            if (cookie.startsWith("app_ftk=")) {
                const appFtk = cookie.substring("app_ftk=".length).trim();

                if (appFtk !== "") {
                    isLoggedin = true;
                }

                break;
            }
        }
    }

    if (__isBrowser__ && window.__initialData__ && window.__initialData__["initialData"] ) {

        initialData = window.__initialData__["initialData"];
        
        // console.log('------------initialData--',initialData);
        // authData = window.__initialData__["authData"];
        authData = global?.userAry;
        // global?.userAry;

        console.log('-----------authData--',authData);
        console.log('------------isdesktop',isDesktop);

        if(initialData && !initialData.error && authData){

            console.log('-----------------------in if');
             const filteredChildList = authData?.childData?.UserChildList?.filter(
                child => !child.IsExpected
            );

            const validChildIds = filteredChildList?.map(child => child.ChildId);

            const filteredVaccinationSummary = initialData?.data1?.vaccinationSummary?.filter(
                item => validChildIds?.includes(item.childId)
            );

            childdata = filteredChildList;
            vaccinationSummary = filteredVaccinationSummary;
            minValues = initialData?.data2?.result.minimum_values;
            maxValues = initialData?.data2?.result.maximum_values;
            stages = initialData?.data3?.stages;
            let realstage =  initialData?.data3?.currentStage
            
            currentStage = stages?.find(stage => stage.stageid == realstage);

        }
        vccBanner_img_mob = initialData?.data4?.result?.find(item => item.type === 'vaccination')?.mob_banner_img;
        vccBanner_img_desk = initialData?.data4?.result?.find(item => item.type === 'vaccination')?.desk_banner_img;


        delete window.__initialData__;
    } else {
      
    }

    if (this.props.location.search.includes('from=app')) {
        isApp = true;
    }

    this.state = {
        vaccinationSummary: vaccinationSummary || [],
        isLoggedin: isLoggedin,
        childlist: childdata || [],
        selectedChild: childdata?.[0] || null,
        isDesktop: isDesktop,
        selectedChildId: null,
        stages:stages,
        allVaccineStages: stages,
        realstage: initialData?.data3?.currentStage ||[],
        vaccineData: currentStage?.vaccine || [],
        givenCnt:vaccinationSummary[0]?.givenCnt||0,
        overdueCnt:vaccinationSummary[0]?.overdueCnt||0,
        upcomingsCnt:vaccinationSummary[0]?.upcomingsCnt||0,
        expandedIndex: null,
        expandedDescIndex: null,
        showFilter: false,
        activeSlideIndex:0,
        win_width: typeof window !== "undefined" ? window.innerWidth : 1200,
        openVaccinePopup: false,
        isApp: isApp,
        articles: [],
        videos: [],
        ageid: null,
        vccBanner_img_mob: vccBanner_img_mob,
        vccBanner_img_desk: vccBanner_img_desk,
        activeBannerIndex: 0,
        iosAuth:'',
        bannerList: [
                {
                    desk: 'https://cdn.cdnparenting.com/brainbees/community/vaccination/osai_banner_01.jpg',
                    mob: 'https://cdn.cdnparenting.com/brainbees/community/vaccination/osai_banner_01.jpg'
                },
                {
                    desk: "https://cdn.cdnparenting.com/brainbees/community/vaccination/osai_banner_02.jpg",
                    mob: "https://cdn.cdnparenting.com/brainbees/community/vaccination/osai_banner_02.jpg"
                },
                {
                    desk: "https://cdn.cdnparenting.com/brainbees/community/vaccination/osai_banner_03.jpg",
                    mob: "https://cdn.cdnparenting.com/brainbees/community/vaccination/osai_banner_03.jpg"
                },
                {
                    desk: "https://cdn.cdnparenting.com/brainbees/community/vaccination/osai_banner_04.jpg",
                    mob: "https://cdn.cdnparenting.com/brainbees/community/vaccination/osai_banner_04.jpg"
                },
                {
                    desk: "https://cdn.cdnparenting.com/brainbees/community/vaccination/osai_banner_05.jpg",
                    mob: "https://cdn.cdnparenting.com/brainbees/community/vaccination/osai_banner_05.jpg"
                }
            ]

    }

    
  }

    static initialAction(reqUrl, ftk, authData, uId, childData, cookieData) {


        let filteredChildList = childData?.UserChildList?.filter(
            child => !child.IsExpected
        ) || [];

        const childinfo = ftk
            ? (filteredChildList || []).map(child => ({
                childid: child.ChildId,
                dob: child.DOB,
                childgender: child.Gender?.toLowerCase() === "boy" ? "0" : "1",
                }))
            : [];


        var LatestFtk = "";
        if (cookieData && cookieData.includes("app_ftk")) {
            var cookieAry = cookieData.split(";");
            for (var i = 0; i < cookieAry.length; i++) {
            if (cookieAry[i] && cookieAry[i].includes("app_ftk")) {
                LatestFtk = cookieAry[i].split("app_ftk=")[1];
            }
            }
        }
        var header = {
            "Content-Type": "application/json",
            ftk: ftk != "" ? ftk : LatestFtk,
            uid: uId,
            "access-token": authData["access-token"],
            "user-agent": global.userAgent,
            isdesktop: global.isdesktop,
        };
            
        let obj1 = {
            url: global.api_url + "vaccinationSummary",
            body: JSON.stringify({
                summaryfilterType: 0,
                childinfo
            })
        };

        let obj2 = {
            url: global.api_url + "getchartgrowthdetails",
            body: JSON.stringify({
                chid: childinfo?.[0]?.childid || "0",
                gender: childinfo?.[0]?.childgender || "0",
                dob: childinfo?.[0]?.dob || "0"
            })
        };

        let obj3 ={
            url: global.api_url + "getVaccinationDetails",
            body: JSON.stringify({
                childid: childinfo?.[0]?.childid || "0",
                childgender: childinfo?.[0]?.childgender || "0",
                dob: childinfo?.[0]?.dob || "0",
                childname: filteredChildList?.[0]?.ChildName || "",
                filterType:'0'
            })
        }

        let obj4 = {
            url: global.api_url + "getBanners",
            body: JSON.stringify({
            })
        }

        // return fetchInitialData3(obj1, obj2, obj4, JSON.stringify(header));
        if (filteredChildList.length === 0) {
            
            return fetchInitialData3(obj1, obj2, obj4, JSON.stringify(header));
        }else{
            
            return fetchInitialData4(obj1, obj2, obj3, obj4, JSON.stringify(header));
        }

        

    }

    componentDidMount() {

        let fcAuthCookie = document.cookie
        .split('; ')
        .find(cookie => cookie.startsWith('FC_AUTH='));

        let fcAuthValue = fcAuthCookie
            ? decodeURIComponent(fcAuthCookie.split('=')[1])
            : '';

        if (!fcAuthValue) {
          let allCookies = document.cookie;
          let appFtkCookie = allCookies.split('; ').find(cookie => cookie.startsWith('app_ftk='));
          fcAuthValue = appFtkCookie ? appFtkCookie.split('=')[1] : null;
        }
        
        console.log("Final auth token value (FC_AUTH or app_ftk):", fcAuthValue);
        this.setState({iosAuth: fcAuthValue})
       
        if (!fcAuthValue || fcAuthValue === 'undefined' || fcAuthValue === '') {
            this.setState({ isLoggedin: false });
        }

        console.log('childlist.length >>>>>>>', this.state.childlist.length);
        console.log('isLoggedin >>>>>>>', this.state.isLoggedin);
        console.log('global.ftk >>>>>>>', global.ftk);

       
        setTimeout(() => {
            if(this.state.childlist.length == 0){
                this.get_child_list();
                // this.getVaccinationDetails();
                
            }
        }, 500);
        


        let params = new URLSearchParams(window.location.search);
        let ageid = params.get("ageid");
        let child_id = params.get("childid");

        // console.log("ageid:", ageid);
        if(this.state.isLoggedin){
            if (ageid){
                console.log('--------------1');
                setTimeout(() => {
                    this.scrollToMainContainer();
                }, 100);
            }


            this.scrollToActive();
        }
        
        this.updateDeviceType(); // calculate first time
        window.addEventListener('resize', this.updateDeviceType);

        if(!this.state.isApp){
            console.log('-------------------desktop');
            window.adpushup = window.adpushup || {};
            window.adpushup.que = window.adpushup.que || [];

            window.adpushup.que.push(function () {
                if (window.adpushup.triggerAd) {
                    window.adpushup.triggerAd("c21ba44c-f89a-460f-bbb9-bc29c66647af");
                }
            });
        }

        if(this.state.isLoggedin){
            const slider = this.ageSliderDivRef.current;

            if (!slider) {
                return;
            }

            this.isDragging = false;
            this.startX = 0;
            this.startScrollLeft = 0;

            this.handleMouseDown = (e) => {
                this.isDragging = true;
                this.startX = e.pageX - slider.offsetLeft;
                this.startScrollLeft = slider.scrollLeft;

                slider.classList.add("is-dragging");
            };

            this.handleMouseMove = (e) => {
                if (!this.isDragging) {
                    return;
                }

                e.preventDefault();

                const x = e.pageX - slider.offsetLeft;
                const walk = x - this.startX;

                slider.scrollLeft =
                    this.startScrollLeft - walk;
            };

            this.handleMouseUp = () => {
                this.isDragging = false;
                slider.classList.remove("is-dragging");
            };

            if (this.state.childlist?.length > 0) {
                slider.addEventListener("mousedown", this.handleMouseDown);
                slider.addEventListener("mousemove", this.handleMouseMove);
                slider.addEventListener("mouseup", this.handleMouseUp);
                slider.addEventListener("mouseleave", this.handleMouseUp);


                if (ageid) {
                    this.setState(
                        {
                            ageid: Number(ageid),
                            selectedChildId: Number(child_id),
                            realstage: Number(ageid)
                        }
                    );

                    let selectedChild = this.state.childlist.find(
                        child => child.ChildId === Number(child_id)
                    );

                    this.setState({
                        selectedChild: selectedChild
                    });

                    this.changeAgeid(Number(ageid))
                }
            }

        }

        const adElement = document.getElementById(
            "938aa2bb-9021-42d7-8f3e-bb08b29fa0a6"
        );

        if (adElement) {
            adElement.style.margin = "0";
        }

     

        // this.bannerInterval = setInterval(() => {
        //     this.setState(prevState => {
        //         if (prevState.bannerList.length <= 1) {
        //             return null;
        //         }

        //         return {
        //             activeBannerIndex:
        //                 (prevState.activeBannerIndex + 1) %
        //                 prevState.bannerList.length
        //         };
        //     });
        // }, 4000);

        if(this.state.isApp){
            
            actions.loadCallbackFile();

            const appMXPJson = {
                appurl: [
                    {
                        pagetype: "handleappdailog",
                        display: '0'
                        
                    }
                ]
            };
            service.jsontracker(JSON.stringify(appMXPJson));
            
        }

    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.realstage !== this.state.realstage) {
            if(this.state.isDesktop){
                this.scrollToActive();
            }
        }
    }

    componentWillUnmount() {
        // const slider = this.ageSliderRef;
        const slider = this.ageSliderRef.current;

        if (!slider) {
            return;
        }

        if(this.state.isLoggedin && this.state.isDesktop && !this.state.isApp){
            slider.removeEventListener("mousedown", this.handleMouseDown);
            slider.removeEventListener("mousemove", this.handleMouseMove);
            slider.removeEventListener("mouseup", this.handleMouseUp);
            slider.removeEventListener("mouseleave", this.handleMouseUp);
        }

        // clearInterval(this.bannerInterval);
    }

    getVaccinationDetails = (child = null) => {
        // Use the passed child, selected child, or first available child
        const selectedChild = child || this.state.selectedChild || this.state.childlist?.[0];

        // Wait until child data is available
        if (!selectedChild?.ChildId) {
            console.log("Child data not available yet");
            return;
        }

        const url = global.api_ci_url + "api/fetchfromCI/getVaccinationDetails";

        const postdata = {
            childid: selectedChild.ChildId,
            childgender: selectedChild.Gender?.toLowerCase() === "boy" ? "0" : "1",
            dob: selectedChild.DOB,
            childname: selectedChild.ChildName,
            filterType: "0"
        };

        console.log("Vaccination API request:", postdata);

        service
            .postServiceCallCookie(url, postdata)
            .then((res2) => {
                console.log('------------------vaccination data', res2);
                const allStage = res2?.stages || [];
                const firstStageId = allStage[0]?.stageid ?? "";

                // Update state after receiving the API response
                this.setState(
                    {
                        selectedChild,
                        selectedChildId: selectedChild.ChildId,
                        activeStatus: "all",
                        stages: allStage,
                        allVaccineStages: allStage,
                        showFilter: false,
                        isClosing: false,
                        isEmpty: allStage.length === 0,
                        realstage: firstStageId,
                        vaccineData: allStage[0]?.vaccine || []
                    },
                    () => {
                        console.log(
                            "Updated vaccination state:",
                            this.state
                        );

                        if (firstStageId) {
                            this.changeAgeid(firstStageId);
                        }
                    }
                );
            })
            .catch((err) => {
                console.error(
                    "Error loading vaccination details:",
                    err
                );

                this.setState({
                    showFilter: false,
                    isClosing: false
                });
            });
    };

    get_child_list = () => {
        console.log("---------------call get_child_list");

        const postData = {
            fcauth: this.state.iosAuth,
            Accesskey: "RmNQYXJlbnRpbmc="
        };

        const url = global.api_ci_url + "Parenting/getChildList";
        console.log('-------------postdata for get_child_list', postData);

        service.postServiceCallCookie(url, postData)
            .then((res) => {
                console.log("getChildList response:", res);

                const childData = Array.isArray(res?.UserChildList)
                    ? res.UserChildList
                    : [];

                // Exclude expected children
                const filteredChildList = childData.filter(
                    child => !child.IsExpected
                );

                const selectedChild = filteredChildList[0] || null;

                this.setState(
                    {
                        childlist: filteredChildList,
                        selectedChild: selectedChild,
                        selectedChildId: selectedChild?.ChildId || null,

                        // Reset child-dependent vaccination data
                        vaccinationSummary: [],
                        givenCnt: 0,
                        overdueCnt: 0,
                        upcomingsCnt: 0,
                        stages: [],
                        allVaccineStages: [],
                        vaccineData: [],
                        realstage: "",
                        ageid: null,

                        // Reset related UI state
                        expandedIndex: null,
                        expandedDescIndex: null,
                        showFilter: false,
                        activeSlideIndex: 0,
                        openVaccinePopup: false
                    },
                    () => {
                        console.log(
                            "Updated child state:",
                            this.state
                        );

                        console.log(
                            "Selected child:",
                            this.state.selectedChild
                        );

                        if (this.state.selectedChild) {
                            // Load details using the latest selected child
                            this.getVaccinationDetails(this.state.selectedChild);
                        }

                        // Load banners independently of child selection
                        this.get_banner_data();
                    }
                );
            })
            .catch((error) => {
                console.error("getChildList API Error:", error);
            });
    };


    
    get_banner_data = () => {
        const postData = {};

        const url =
            global.api_ci_url + "api/fetchfromCI/getBanners";

        service.postServiceCallCookie(url, postData)
            .then((res) => {
                console.log("Banner API response:", res);

                const bannerData = res?.result || [];

                const vaccinationBanner = bannerData.find(
                    (item) => item.type === "vaccination"
                );

                this.setState(
                    {
                        vccBanner_img_mob:
                            vaccinationBanner?.mob_banner_img || "",
                        vccBanner_img_desk:
                            vaccinationBanner?.desk_banner_img || "",
                        bannerList: bannerData
                    },
                    () => {
                        console.log(
                            "Updated banner state:",
                            this.state
                        );

                    }
                );
            })
            .catch((err) => {
                console.error("Error loading banners:", err);
            });
    };


    scrollToMainContainer = () => {
        const element = this.mainContainerRef.current;

        if (element) {
            element.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        }
    };

    

    scrollToActive = () => {
        const container = this.ageSliderDivRef.current;

        console.log('----------container----', container);

        if (!container) return;

        requestAnimationFrame(() => {
            const activeElement = container.querySelector(".activeage");

            console.log('-----------123-',activeElement);

            if (!activeElement) return;

            const containerRect = container.getBoundingClientRect();
            const activeRect = activeElement.getBoundingClientRect();

            const activeCenter =
                activeRect.left + activeRect.width / 2;

            const containerCenter =
                containerRect.left + containerRect.width / 2;

            const scrollAmount =
                activeCenter - containerCenter;

            container.scrollTo({
                left: container.scrollLeft + scrollAmount,
                behavior: "smooth"
            });
        });
    };




    addVaccineDetails =(data)=>{
        document.documentElement.style.overflow = "";
        let vaccArr = this.state.vaccineData;
        let vaccineId = this.state.selectedVaccineId;

        const vaccineDetails = vaccArr.find(
            v => v.vaccineid == vaccineId
        );

        if(this.state.isApp){
            actions.loadCallbackFile();
            const eventName = "vg_vaccine_detail_page_community";
            const eventData = {
                "action_type":'mark done',
                "birth_week": vaccineDetails.stagetitle,
                "vaccination_status": vaccineDetails.vaccineStatus,
                "reminder_date": vaccineDetails.reminderdate,
                "vaccine_taken_on":vaccineDetails.givenOn,
                "vaccination_name":vaccineDetails.vaccinetitle,
                sendWithoutGtm: "yes" //mixpanel event send without GTM
            };
            service.createfinalTrackingObject(eventName, eventData);
        }

        let dobcheck = new Date(this.state.selectedChild?.DOB);
        var today = new Date();
        var age = Math.floor((today - dobcheck) / (365.25 * 24 * 60 * 60 * 1000));

        let dt = Math.floor(new Date(data.date).getTime() / 1000);

        let height = data.heightUnit;
        let headCir = data.hcUnit;
        let heightunit ="cm";
        let headCirunit = "cm";
        let ht = data.height;
        let hc = data.hc;
        
        if(height == "in"){
            height = 1;
            heightunit = "inc"
            ht = parseFloat(ht) / 0.39370;
            ht = parseFloat(ht).toFixed(3);
        }else{
            height = 0;
            heightunit = "cm"
            ht = ht
        }

        if(headCir == "in"){
            headCir = 1;
            headCirunit = "inc";
            hc = parseFloat(hc) / 0.39370;
            hc = parseFloat(hc).toFixed(3);
        }else{
            headCir = 0;
            headCirunit = "cm";
            hc = hc;
        }   

        let postdata ={
            "vaccineid":vaccineDetails.vaccineid,
            "childid":this.state.selectedChild?.ChildId,
            "doseid":vaccineDetails.doseid,
            "comment":'',
            "imageurl":'',
            "markdate": data.date,
            "stageid":vaccineDetails.stageid,
            "week":age,
            "wt": data.weight,
            "ht": ht,
            "hc": hc,
            "htut": height,
            "hcut": headCir,
            "dt": dt,   
            "user_agent" :navigator.userAgent,
            "is_user_desk" :this.state.isDesktop,
            "takeon":data.date,
            "sourceid" :Math.random().toString(36),
            "deviceToken" :Math.random().toString(36),
            "advertisingID" :Math.random().toString(36)
        }

        console.log('----------postdata', postdata);

        let url = global.api_ci_url + "api/fetchfromCI/setmarkdonestatus"; 

        service.postServiceCall(url, postdata)
        .then((json) => {
            // console.log('---------json', json);

            if (json.msg == 1) {
                this.setState((prevState) => {
                    const updatedVaccineData = prevState.vaccineData.map(vaccine => {
                        if (vaccine.vaccineid == vaccineDetails.vaccineid) {

                            return {
                                ...vaccine,
                                vaccineStatus: "Given",
                                givenstatus: 1,
                                takenon: data.date,
                                givenOn: data.date
                            };
                        }
                        return vaccine;
                    });
                    return {
                        vaccineData: updatedVaccineData,
                        givenCnt: prevState.givenCnt + 1,
                        overdueCnt:
                            prevState.overdueCnt > 0
                                ? prevState.overdueCnt - 1
                                : 0,
                        showMarkdone: false
                    };
                });
            }
        })
        .catch((error) => {
            console.error("Error toggling like:", error);
            service.hideLoader();
        });

        
        this.setState ({
            showMarkdone: false
        });

    }


    getLatestChildData =(data)=>{

        if(this.state.isApp){
            actions.loadCallbackFile();
            const eventName = "child_selected";
            const eventData = {
                'child_name':data.ChildName,
                'page_type':'vaccination',
                'child_gender':data.Gender,
                sendWithoutGtm: "yes" //mixpanel event send without GTM
            };
            service.createfinalTrackingObject(eventName, eventData);
        }

        const childinfo = {
            childid: data.ChildId,
            dob: data.DOB,
            childgender: data.Gender?.toLowerCase() == "boy" ? "0" : "1",
        };

        let postdata = {
            summaryfilterType: 0,
            childinfo: [childinfo]
        }

        let url = global.api_ci_url + "api/fetchfromCI/vaccinationSummary"; 
        
        service.postServiceCall(url, postdata)
        .then((json) => {

            console.log('-----------------json', json)

            if(json.msg == 1){
                
                this.setState({
                    selectedChild: data, // update selected child also
                    givenCnt : json?.vaccinationSummary?.[0]?.givenCnt,
                    overdueCnt: json?.vaccinationSummary?.[0]?.overdueCnt,
                    upcomingsCnt: json?.vaccinationSummary?.[0]?.upcomingsCnt
                });

                document.querySelector(".select_child_popup.addAns-overlay").style.display="none";

                let url2 = global.api_ci_url + "api/fetchfromCI/getVaccinationDetails"; 
                let postdata2 = {
                    childid: data.ChildId,
                    childgender: data.Gender?.toLowerCase() == "boy" ? "0" : "1",
                    dob: data.DOB,
                    childname:data.ChildName,
                    filterType:'0'
                }

                return service.postServiceCall(url2, postdata2)
                .then((res2) => {
                    console.log('----------------response2', res2);
                    let realstage =  res2.currentStage;
                    let currentStage = res2.stages.find(stage => stage.stageid == realstage);
                    this.setState({
                        realstage : res2.currentStage,
                        stages: res2.stages,
                        allVaccineStages: res2.stages,
                        vaccineData: currentStage.vaccine,
                        activeStatus:""
                    });
                });

            }
            document.documentElement.style.overflow = "";
            document.querySelector("body").style.overflow = "";
            
        })
        .catch((error) => {
            console.error("Error toggling like:", error);
            service.hideLoader();
            document.documentElement.style.overflow = "";
        });
        document.documentElement.style.overflow = "";
        document.querySelector("body").style.overflow = "";
    }

    updateDeviceType = () => {
        const isDesktop = window.innerWidth >= 768;
        const win_width = window.innerWidth;

        this.setState({
            isDesktop,
            win_width
        });
    }

    toLogin = () => {

        if (this.state.isApp) {
            actions.loadCallbackFile();
    
            const eventName = "add_your_child_detail_click";
            const eventData = {
                page_type: "growth",
                sendWithoutGtm: "yes"
            };
    
            service.createfinalTrackingObject(eventName, eventData);
        }
    
        // NON-LOGIN USER
        if (!this.state.isLoggedin) {
    
            // APP → Native login callback
            if (this.state.isApp) {
    
                const appMXPJson = {
                    appurl: [
                        {
                            pagetype: "login",
                            url: "https://www.firstcry.com/m/login?from=app"
                            // redirecturl: global.currentURL
                        }
                    ]
                };
    
                service.jsontracker(JSON.stringify(appMXPJson));
                return;
            }
    
            // MS / DS → Existing web login flow
            service.showAlert("Please Login");
            window.location.href = global.loginUrl + "?URL=" + global.currentURL;
    
            return;
        } else{
            if (this.state.isApp) {

                console.log('------------------callback for child add')

                const appMXPJson = {
                    appurl: [
                        {
                            pagetype: "child",
                        },
                    ],
                };

                service.jsontracker(JSON.stringify(appMXPJson));

                return;
            }
        }
    
        // LOGGED-IN USER
        const url = "/my-account/myprofile?growthtracker";
    
        window.location.href = service.getRedirectUrl(url);
    };

     openprofilePopup=() =>{
        if(global.ftk != ""){
            document.querySelector(".select_child_popup").style.display="block";
        }
        if(!this.state.isDesktop){
            document.documentElement.style.overflow = "hidden";
            document.querySelector("body").style.overflow = "hidden";
        }
        
    }

    changeAgeid = (stageid) => {

        console.log('----------stageid--',stageid);

        this.setState({
			ageid: Number(stageid)
		});
        console.log('----this.state.expandedIndex',this.state.expandedIndex);

        const currentStage = this.state.stages.find(
            stage => String(stage.stageid) === String(stageid)
        );

        this.setState({
            expandedIndex: null,
            realstage: stageid,
            vaccineData: currentStage?.vaccine || []
        }, () => {
            console.log("Updated vaccineData:", this.state.vaccineData);
        });


        setTimeout(() => {
            this.scrollToActive();
        }, 50);

    };


    showVaccineStatus = (status) => {

        this.setState({ isClosing: true });

        if(this.state.isApp){
            actions.loadCallbackFile();
            const eventName = "vg_filter_click";
            const eventData = {
                "action_type":'filter clicked',
                "filter_selected": status,
                sendWithoutGtm: "yes" //mixpanel event send without GTM
            };
            service.createfinalTrackingObject(eventName, eventData);
        }
		
        setTimeout(() => {

        let url = global.api_ci_url + "api/fetchfromCI/getVaccinationDetails";

        let postdata = {
            childid: this.state.selectedChild?.ChildId,
            childgender:
                this.state.selectedChild?.Gender?.toLowerCase() === "boy"
                    ? "0"
                    : "1",
            dob: this.state.selectedChild?.DOB,
            childname: this.state.selectedChild?.ChildName,
            filterType: "0"
        };

        service.postServiceCall(url, postdata)
            .then((res2) => {

                const allStage = res2.stages || [];

                if (status !== "all") {

                    let filteredStages = allStage
                        .map(stage => ({
                            ...stage,
                            vaccine:
                                stage.vaccine?.filter(
                                    v =>
                                        v.vaccineStatus?.toLowerCase() ===
                                        status.toLowerCase()
                                ) || []
                        }))
                        .filter(stage => stage.vaccine.length > 0);

                    const isEmpty = filteredStages.length < 1;

                    if (status === "upcoming") {

                        const firstStageId =
                            filteredStages?.[0]?.stageid || "";

                        this.setState(
                            {
                                activeStatus: status,
                                stages: filteredStages,
                                allVaccineStages: allStage,
                                showFilter: false,
                                isClosing: false,
                                isEmpty,
                                realstage: firstStageId
                            },
                            () => {
                                if (firstStageId) {
                                    this.changeAgeid(firstStageId);
                                }

                                setTimeout(() => {
                                    this.scrollToAgeSlider();
                                }, 100);
                            }
                        );

                    } else {

                        const lastIndex =
                            filteredStages.length - 1;

                        const lastStageId =
                            filteredStages?.[lastIndex]?.stageid || "";

                        this.setState(
                            {
                                activeStatus: status,
                                stages: filteredStages,
                                allVaccineStages: allStage,
                                showFilter: false,
                                isClosing:false,
                                isEmpty,
                                realstage: lastStageId
                            },
                            () => {
                                if (lastStageId) {
                                    this.changeAgeid(lastStageId);
                                }

                                setTimeout(() => {
                                    console.log('---------------2');
                                    if (this.sliderRef) {
                                        // this.sliderRef.slickGoTo(lastIndex);
                                    }

                                    // this.sliderRef?.innerSlider?.onWindowResized();
                                    this.scrollToAgeSlider();
                                }, 100);
                            }
                        );
                    }

                } else {

                    const firstStageId = allStage?.[0]?.stageid || "";
                    // const firstStageId = this.state.realstage || allStage?.[0]?.stageid || "";

                    this.setState(
                        {
                            activeStatus: "all",
                            stages: allStage,
                            allVaccineStages: allStage,
                            showFilter: false,
                            isClosing:false,
                            isEmpty: false,
                            realstage: firstStageId
                        },
                        () => {
                            if (firstStageId) {
                                this.changeAgeid(firstStageId);
                            }

                            const activeIndex = allStage.findIndex(
                                s => s.stageid == firstStageId
                            );

                            setTimeout(() => {
                                console.log('---------------3');
                                if (this.sliderRef) {
                                    // this.sliderRef.slickGoTo(0);
                                }
                                // if (activeIndex >= 0) {
                                //     this.sliderRef.slickGoTo(activeIndex);
                                // }
                                // this.sliderRef?.innerSlider?.onWindowResized();
                                this.scrollToAgeSlider();
                            }, 100);
                        }
                    );
                }
            })
            .catch(err => {
                console.error("Error loading vaccination details", err);
                 this.setState({
                    showFilter: false,
                    isClosing: false
                });
            });
            document.documentElement.style.overflow = "";
        }, 300);
    };

    showVaccineDetails = (index, id) => {
        const isOpening = this.state.expandedIndex !== index;

        if (isOpening) {
            const selectedVaccine = this.state.vaccineData[index];

            console.log('----------selectedVaccine', selectedVaccine);

            const stageMap = {
                "birth": 0,
                "6 weeks": 1,
                "10 weeks": 2,
                "14 weeks": 3,
                "6 months": 4,
                "9 months": 5,
                "12 months": 6,
                "15 months": 7,
                "16 to 18 months": 8,
                "4 to 6 years": 9,
                "9 to 14 years": 10,
                "15 to 18 years": 11
            };


            const stageIndex = stageMap[selectedVaccine.stagetitle.toLowerCase().trim()];

            console.log('-----------stageIndex',stageIndex);

            service.postServiceCall(global.api_ci_url + "api/fetchfromCI/getVaccineContent", {
                id,
                age: stageIndex
            }).then((res) => {
                if (res.msg === 1) {
                    const articles = res.result.articles || [];
                    const videos = res.result.videos || [];

                    this.setState(
                        {
                            articles,
                            videos
                        },
                        () => {
                            const element = this.descriptionRefs[index];

                            if (element) {
                                const y =
                                    element.getBoundingClientRect().top +
                                    window.pageYOffset -
                                    80; // adjust header height

                                window.scrollTo({
                                    top: y,
                                    behavior: "smooth"
                                });
                            }
                        }
                    );

                }
            });
        }

        this.setState({
            expandedIndex: isOpening ? index : null
        });
    };



    openVaccineDetailsPopup=(index, id)=>{

        const vaccineData = this.state.vaccineData;
        const selectedVaccine = vaccineData[index];

        const stageMap = {
            "birth": 0,
            "6 weeks": 1,
            "10 weeks": 2,
            "14 weeks": 3,
            "6 months": 4,
            "9 months": 5,
            "12 months": 6,
            "15 months": 7,
            "16 - 18 months": 8,
            "4 to 6 years": 9,
            "9 to 14 years": 10,
            "15 to 18 years": 11
        };

        const stageIndex =
            stageMap[selectedVaccine.stagetitle.toLowerCase().trim()];

        const url = global.api_ci_url + "api/fetchfromCI/getVaccineContent";

        const postdata = {
            id,
            age: stageIndex
        };

        service.postServiceCall(url, postdata)
            .then((res2) => {

                this.setState({
                    openVaccinePopup: true,
                    selectedVaccineId: id,
                    articles: res2?.msg === 1 ? (res2.result.articles || []) : [],
                    videos: res2?.msg === 1 ? (res2.result.videos || []) : []
                });

                if(!this.state.isDesktop){
                    // document.documentElement.style.overflow = "hidden";
                    document.querySelector("body").style.overflow = "hidden";
                    this.lockBodyScroll();
                }
                
            })
            .catch((err) => {
                console.error(err);

                this.setState({
                    openVaccinePopup: true,
                    selectedVaccineId: id,
                    articles: [],
                    videos: []
                });

                if(!this.state.isDesktop){
                    // document.documentElement.style.overflow = "hidden";
                    document.querySelector("body").style.overflow = "hidden";
                    this.lockBodyScroll();
                }
            });

  
        if(this.state.isApp){
            actions.loadCallbackFile();
            const eventName = "vg_vaccine_detail_page_community";
            const eventData = {
                "action_type":'learn more',
                "birth_week": selectedVaccine.stagetitle,
                "vaccination_status": selectedVaccine.vaccineStatus,
                "reminder_date": selectedVaccine.reminderdate,
                "vaccine_taken_on":selectedVaccine.givenOn,
                "vaccination_name":selectedVaccine.vaccinetitle,
                sendWithoutGtm: "yes" //mixpanel event send without GTM
            };
            service.createfinalTrackingObject(eventName, eventData);
        }

    }

    closeVaccineDetailsPopup=()=>{
        this.setState({
            openVaccinePopup: false
        })
        document.documentElement.style.overflow = "";
        document.querySelector("body").style.overflow = "";
        if (!this.state.isDesktop) {
            this.unlockBodyScroll();
        }
    }

    toggleReadMore = (index) => {
        console.log('-----------index', index);
        this.setState(prevState => ({
            expandedDescIndex: prevState.expandedDescIndex === index ? null : index
        }));


        if(this.state.isApp){
            const vaccineData = this.state.vaccineData;
            const selectedVaccine = vaccineData[index];

            actions.loadCallbackFile();
            const eventName = "vg_vaccine_detail_page_community";
            const eventData = {
                "action_type":'read more',
                "birth_week": selectedVaccine.stagetitle,
                "vaccination_status": selectedVaccine.vaccineStatus,
                "reminder_date": selectedVaccine.reminderdate,
                "vaccine_taken_on":selectedVaccine.givenOn,
                "vaccination_name":selectedVaccine.vaccinetitle,
                sendWithoutGtm: "yes" //mixpanel event send without GTM
            };
            service.createfinalTrackingObject(eventName, eventData);
        }

    };
    openFilterPopup =()=>{
        console.log('-------openfilter');
       

        this.setState({
            showFilter: true
        })
        if(this.state.isApp){
            document.querySelector("body").style.overflow = "hidden";
        }
        

        document.documentElement.style.overflow = "hidden";
        
    }

    closeFilter = () => {
        this.setState({ isClosing: true });
        document.querySelector("body").style.overflow = "";
        setTimeout(() => {
            this.setState({
                showFilter: false,
                isClosing: false
            });

            document.documentElement.style.overflow = "";

            if (this.state.isApp) {
                
                actions.loadCallbackFile();

                const eventName = "vg_filter_click";
                const eventData = {
                    action_type: "cancel",
                    filter_selected: "",
                    sendWithoutGtm: "yes"
                };

                service.createfinalTrackingObject(eventName, eventData);
            }
        }, 300); // Match CSS animation duration
    };

    openMarkdonePopup=(id)=>{
        this.setState({
            showMarkdone:true,
            selectedVaccineId: id
        })
        if(!this.state.isDesktop){
            document.documentElement.style.overflow = "hidden";
            document.querySelector("body").style.overflow = "hidden";
        }
        
    }
    closeMarkDone=()=>{
        this.setState({
            showMarkdone:false,
            selectedVaccineId: ""
        })
        document.documentElement.style.overflow = "";
        document.querySelector("body").style.overflow = "";
    }

    openStatusPopup=(id,index)=>{
        this.setState({
            showStatus:true,
            selectedVaccineId: id
        })
        if(!this.state.isDesktop){
            document.documentElement.style.overflow = "hidden";
            document.querySelector("body").style.overflow = "hidden";
        }

        // console.log('------------view status',index);
        const vaccineData = this.state.vaccineData;
        const selectedVaccine = vaccineData[index];


        if(this.state.isApp){
            actions.loadCallbackFile();
            const eventName = "vg_vaccine_detail_page_community";
            const eventData = {
                "action_type":'view details',
                "birth_week": selectedVaccine.stagetitle,
                "vaccination_status": selectedVaccine.vaccineStatus,
                "reminder_date": selectedVaccine.reminderdate,
                "vaccine_taken_on":selectedVaccine.givenOn,
                "vaccination_name":selectedVaccine.vaccinetitle,
                sendWithoutGtm: "yes" //mixpanel event send without GTM
            };
            service.createfinalTrackingObject(eventName, eventData);
        }


    }
   
    closeShowStatus=()=>{
        this.setState({
            showStatus:false,
            selectedVaccineId: ""
        })
        document.documentElement.style.overflow = "";
        document.querySelector("body").style.overflow = "";
    }
    // closeChildList=()=>{

    //     document.querySelector(".select_child_popup").style.display="none";
    //     document.documentElement.style.overflow = "";
    // }

     closeChildList = () => {
        const popup = document.querySelector(".select_child_popup");

        popup.classList.add("fade-out");

        setTimeout(() => {
            popup.style.display = "none";
            popup.classList.remove("fade-out");
            document.documentElement.style.overflow = "";
            document.querySelector("body").style.overflow = "";
        }, 600); // Match CSS transition duration
    }

    // goBack = () => {
    //     window.history.back();
    // }

    goBack = () => {
        const isApp = window.location.href.includes("from=app");
        if (!isApp) {
            window.history.back();
            return;
        }
        const currentUrl = window.location.href;
        window.history.back();
        setTimeout(() => {
            // Still on same page => history back did not navigate
            if (window.location.href === currentUrl) {
                const deepjson = {
                    appurl: [
                        {
                            pagetype: "onBackPressed",
                            isFinishWindow: true
                        }
                    ]
                };
                service.jsontracker(JSON.stringify(deepjson));
            }
        }, 500);
    };



    openFaq=()=>{

        const faq_data = document.querySelector(".showFaq-overlay");

        if (faq_data) {
            faq_data.style.display = "block";
        }


        document.documentElement.style.overflow = "hidden";
        document.querySelector("body").style.overflow = "hidden";
    }
    closefaqPopup =()=>{

        const faq_data = document.querySelector(".showFaq-overlay");

        if (faq_data) {
            faq_data.style.display = "none";
        }
        document.documentElement.style.overflow = "";
        document.querySelector("body").style.overflow = "";
    }

    openDisclaimer=()=>{
        const disclaimer = document.querySelector(".showDisc-overlay");

        if (disclaimer) {
            disclaimer.style.display = "block";
        }

        document.documentElement.style.overflow = "hidden";
        document.querySelector("body").style.overflow = "hidden";
    }

        
    closeDisclaimer=()=>{
        const disclaimer = document.querySelector(".showDisc-overlay");

        if (disclaimer) {
            disclaimer.style.display = "none";
        }
        document.documentElement.style.overflow = "";
        document.querySelector("body").style.overflow = "";
    }

    openFeedback=()=>{
        this.setState({
            showFeedbackPopup: true,
        })
        // window.location.href = "/tools/baby-growth-tracker-chart/feedback/";
        document.documentElement.style.overflow = "hidden";
        document.querySelector("body").style.overflow = "hidden";
    }

    closeFeedback=()=>{
        this.setState({
            showFeedbackPopup: false,
        })
        document.documentElement.style.overflow = "";
        document.querySelector("body").style.overflow = "";
    }

    bannerEvent=(e)=>{

        let url = new URL(window.location.href); // Get the current URL
        let params = new URLSearchParams(url.search); // Get the search parameters
        // Get the value of the ref2 parameter
        let ref2Value = params.get('ref2') || ""; 
        
        if(this.state.isApp){
            actions.loadCallbackFile();
            const eventName = "vg_banner_click";
            const eventData = {
                "component_type": 'Vaccination banner',
                "image_url": e.target.src,
                "page_type": "vaccination",
                "ref2":ref2Value,
                sendWithoutGtm: "yes" //mixpanel event send without GTM
            };
            service.createfinalTrackingObject(eventName, eventData);
        }
    }

    // vaccinationArticleEvent=(title,id)=>{
       vaccinationArticleEvent(articleURL, e, title, id) {

        if (this.state.isApp) {
            actions.loadCallbackFile();
            const eventName = "vg_article_video_community";
            const eventData = {
                action_type: 'article_vaccine',
                page_type: 'vaccination',
                article_name: title,
                article_id: id,
                video_name: '',
                video_id: '',
                sendWithoutGtm: "yes"
            };
            service.createfinalTrackingObject(eventName, eventData);


            let appMXPJson = {
                "appurl": [
                    {
                        "pagetype": "communitywebview",
                        "feed":"true",
                        "communityWebViewUrl": articleURL + '?from=app',
                        "communityWebViewTitle": title,
                        "requestURL": articleURL + '?from=app'
                    }
                ]

            }
            // service.jsontracker(JSON.stringify(appMXPJson));
            setTimeout(() => {
                service.jsontracker(JSON.stringify(appMXPJson));
            }, 500); // Adjust the time (in milliseconds) as needed

        }else{
             e.currentTarget.href = `${articleURL}`;
        }


    }
    vaccinationVideoEvent=(title,id)=>{
        if (this.state.isApp) {
            actions.loadCallbackFile();
            const eventName = "vg_article_video_community";
            const eventData = {
                action_type: 'video_vaccine',
                page_type: 'vaccination',
                article_name: '',
                article_id: '',
                video_name: title,
                video_id: id,
                sendWithoutGtm: "yes"
            };
            service.createfinalTrackingObject(eventName, eventData);
        }

    }

    scrollToAgeSlider = () => {
        console.log('------------scroll to age tab');
        if (this.ageSliderRef.current) {
            const y =
                this.ageSliderRef.current.getBoundingClientRect().top +
                window.pageYOffset -
                (-10); // header height

            window.scrollTo({
                top: y,
                behavior: "smooth"
            });
        }
    };


    lockBodyScroll = () => {
        this.scrollPosition = window.pageYOffset;

        document.body.style.position = "fixed";
        document.body.style.top = `-${this.scrollPosition}px`;
        document.body.style.left = "0";
        document.body.style.right = "0";
        document.body.style.width = "100%";
    };

    unlockBodyScroll = () => {
        document.body.style.position = "";
        document.body.style.top = "";
        document.body.style.left = "";
        document.body.style.right = "";
        document.body.style.width = "";

        window.scrollTo(0, this.scrollPosition || 0);
    };

  
    render() {

        const { articles, videos } = this.state;
        const showArticleNavigation = articles && articles.length > 3;
        const params = {
            slidesPerView: 3.35,
            spaceBetween: 25,
            slidesOffsetAfter: 20,
            loop: false,
            speed: 600,          // Smooth slide animation
            centeredSlides: false,
            navigation: showArticleNavigation ? {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            } : false,
        };


        const showNavigation = videos && videos.length >= 4;

        const videoParams = {
            slidesPerView: 3.2,
            spaceBetween: 25,
            slidesOffsetAfter: 20,
            loop: false,
            nested: true,
            simulateTouch: true,
            touchStartPreventDefault: false,

            mousewheel: {
                forceToAxis: true,
                releaseOnEdges: true,
            },
            navigation: showNavigation
                ? {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                }
                : false,

            on: {
                slideChange: () => {
                    Object.keys(this.playersRef).forEach(id => {
                        try {
                            this.playersRef[id].pauseVideo();
                        } catch (e) {}
                    });
                }
            }
        };

        const bannerParams = {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            speed: 600,

            autoplay: {
                delay: 4000,
                disableOnInteraction: false
            },

            pagination: {
                el: ".swiper-pagination",
                clickable: true
            },

            observer: true,
            observeParents: true,

            rebuildOnUpdate: true,
            shouldSwiperUpdate: true
        };


            const { stages=[], realstage } = this.state;
            
            const NextArrow = ({ className, style, onClick }) => (
                <div className="custom-next" onClick={onClick}>
                    <img src="https://cdn.cdnparenting.com/brainbees/community/babyname/ic-circle-forward-arrow.svg" alt="Next" />
                </div>
            );

            const PrevArrow = ({ className, style, onClick }) => (
                <div className="custom-prev" onClick={onClick}>
                    <img src="https://cdn.cdnparenting.com/brainbees/community/babyname/ic-circle-backword-arrow.svg" alt="Previous" />
                </div>

            );


            const activeIndex = stages?.findIndex(
                s => s.stageid == realstage
            ) ?? 0;

            const capitalize = (str) =>
            str ? str.charAt(0).toUpperCase() + str.slice(1) : "";

             const hasMedia =(articles && articles.length > 0) || (videos && videos.length > 0);
        
        return (

            <>
                <div className={`${(this.state.isLoggedin==true && this.state.childlist.length > 0) ? 'maincontainer_1':'maincontainer_1_nonlog'}`} >
                    <div className="outerContainerVcc">
                        <div className="main-container">
                            <Helmet>
                                <title>Child Immunization Schedule & Newborn Vaccination List – FirstCry Parenting</title>
                                <meta name="description" content="Check the complete child immunization schedule and newborn vaccination list in India. View age-wise vaccine chart, benefits, and important vaccines to protect your baby from birth through childhood." />
                                <meta name="keywords" content="immunization schedule, immunization calendar, vaccination schedule"/>
                                <link rel="canonical" href="https://parenting.firstcry.com/tools/vaccine-immunization-tracker/" />
                            </Helmet>
                            
        
                            {/* {!this.state.isLoggedin ? ( */}
                            {(!this.state.isLoggedin || this.state.childlist.length === 0) ? (
                            <>
                                
                                {this.state.isDesktop && ( 
                                <div className="titlegrowthTracker">
                                    <div className="breadcrumbvcc ">
                                        <span><a href={service.getRedirectUrl("/")} className="">Home</a></span>
                                        <span className=" breadcrum_icon" data-icon-font="l"></span>
                                        <span><a href={service.getRedirectUrl("/tools/")} className="">Tools</a></span>
                                        <span className=" breadcrum_icon" data-icon-font="l"></span>
                                        <span>Child Immunization Schedule</span>
                                    </div>
                                    <hr className="titlehr"></hr>
                                </div>
                                )}
                                <Nonloggedin  eleRef={this} type={"vaccination"}/>
                            
                            </>
                            ): (
                            <>
                                <div className="titlegrowthTracker">
                                    {this.state.isDesktop && ( 
                                        <div className="breadcrumbvcc ">
                                            <span><a href={service.getRedirectUrl("/")} className="">Home</a></span>
                                            <span className=" breadcrum_icon" data-icon-font="l"></span>
                                            <span><a href={service.getRedirectUrl("/tools/")} className="">Tools</a></span>
                                            <span className=" breadcrum_icon" data-icon-font="l"></span>
                                            <span>Child Immunization Schedule</span>
                                        </div>
                                    )}
                                    <div className="title_filter">
                                        {this.state.isDesktop ? ( 
                                            <h1 className="R28_21" id="skipToH1" aria-label="Vaccination Tracker">Vaccination Tracker</h1>
                                        ):(
                                            <h1 className="mob_Vcc_Title" aria-label="Vaccination Tracker">
                                                <img className="mob_back_arrow" src="https://cdn.cdnparenting.com/brainbees/community/vaccination/left_arrow.png" onClick={()=>this.goBack()} alt="back img"></img>
                                                {capitalize(this.state.selectedChild?.ChildName)}'s Vaccination Tracker
                                            </h1>
                                        )}
                                        <div className="vaccineFilter" onClick={()=>this.openFilterPopup()} >
                                            {/* <img src="https://cdn.cdnparenting.com/brainbees/community/vaccination/filter.png" alt="filter"></img> */}
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M20.1745 2V3.38402H3.82529V2H20.1745ZM10.4878 17.4684L10.4972 17.6431C10.5408 18.0464 10.7336 18.4198 11.0393 18.6825L13.1525 20.498C13.4451 20.7494 13.88 20.5642 13.9333 20.1949L13.9389 20.1187V11.498C13.939 11.2383 14.0382 10.9889 14.2151 10.8041L20.1745 4.5808L20.5153 4.22562C20.8143 3.91342 20.6001 3.38402 20.1745 3.38402V2C21.7917 2 22.6073 4.01111 21.4713 5.19753L15.2815 11.6601V20.1187C15.2814 21.7105 13.4803 22.5802 12.2939 21.5616L10.1807 19.7461C9.52505 19.1829 9.14531 18.3482 9.1452 17.4684V11.6862L2.56975 5.23903C1.37794 4.07039 2.18044 2.0001 3.82529 2V3.38402C3.39255 3.38412 3.18134 3.92871 3.49479 4.23624L10.1901 10.8002C10.3802 10.9867 10.4877 11.2458 10.4878 11.5163V17.4684Z" fill="#212121"/>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                                {this.state.isDesktop && ( 
                                    <hr className="titlehr"></hr>
                                )}
                                <div className="subcontainer1">
                                    <div className="questionLeft_outer questionLeft">
                                        <div className="questionLeft_1">
                                            <div className="loggedin_div">
                                                <div className="nonlog_slider_wrapper nonlog_slider_wrapper_VCC">        
                                                    <div className={`${this.state.isDesktop?"banner_card":"mob_banner_card"}`} >
                                                        {this.state.isDesktop ? ( 
                                                            <img src={this.state.vccBanner_img_desk} onClick={this.bannerEvent} alt="Child Immunization & Vaccination Schedule" title="Child Immunization & Vaccination Schedule" className="GTMTopBanner" data-page="vaccination"/>
                                                        ):(
                                                            <img src={this.state.vccBanner_img_mob} onClick={this.bannerEvent}  alt="Child Immunization & Vaccination Schedule" title="Child Immunization & Vaccination Schedule" className="GTMTopBanner" data-page="vaccination"/>
                                                        )}
                                                    </div>


                                                    {/* <div className={`${this.state.isDesktop ? "banner_card" : "mob_banner_card"} `}>
                                                        <div className="customBannerCarousel">
                                                            <div className="bannerSliderTrack" style={{ transform: `translateX(-${this.state.activeBannerIndex * 100}%)`}}>
                                                                {this.state.bannerList.map((banner, index) => (
                                                                    <div className="bannerSlide" key={index}>
                                                                        <img
                                                                            src={this.state.isDesktop ? banner.desk : banner.mob}
                                                                            alt="Child Growth Tracker"
                                                                            title="Child Growth Tracker"
                                                                            className="GTMTopBanner"
                                                                            data-page="growth"
                                                                            onClick={this.state.isDesktop ? undefined : this.growthBannerEvent}
                                                                        />
                                                                    </div>
                                                                ))}
                                                            </div>

                                                            
                                                            {this.state.bannerList.length > 1 && (
                                                                <div className="bannerDots">
                                                                    {this.state.bannerList.map((_, index) => (
                                                                        <span
                                                                            key={index}
                                                                            className={`bannerDot ${
                                                                                this.state.activeBannerIndex === index ? "active" : ""
                                                                            }`}
                                                                            onClick={() =>
                                                                                this.setState({
                                                                                    activeBannerIndex: index
                                                                                })
                                                                            }
                                                                        />
                                                                    ))}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div> */}
                                                    {/* <div className={`${this.state.isDesktop?"banner_card":"mob_banner_card"}`} >
                                                        <Swiper {...bannerParams}>
                                                            {this.state.bannerList.map((banner, index) => (
                                                                <div className="bannerSlide" key={index}>
                                                                    <img src={this.state.isDesktop ? banner.desk : banner.mob}
                                                                        alt={`Banner ${index + 1}`}
                                                                        title={`Banner ${index + 1}`}
                                                                        className="GTMTopBanner"
                                                                        data-page="vaccination"
                                                                        onClick={this.bannerEvent}
                                                                    />
                                                                </div>
                                                            ))}
                                                            
                                                        </Swiper>
                                                    </div> */}

                                                </div>
                                                
            
                                                {/* Child select start */}
                                                <div className="vcc_dropdown_sec_wrap growth_tr_child_select" ref={this.ageSliderRef}>
                                                    <div className="vcc_dropdown_head" onClick={()=>this.openprofilePopup()}>
                                                        <div className="vcc_select_child M20_21">
                                                            <div className="vcc_dropdown_row">
                                                                <div className="profile_name_img">
                                                                    <div className="vcc_arti_circle_img sel_profile">
                                                                        <img 
                                                                            src={
                                                                                this.state.selectedChild?.childPhoto
                                                                                ? this.state.selectedChild.childPhoto
                                                                                : this.state.selectedChild?.Gender?.toLowerCase() == "boy"
                                                                                    ? "https://cdn.cdnparenting.com/brainbees/community/vaccination/ic_boy_community.png"
                                                                                    : "https://cdn.cdnparenting.com/brainbees/community/vaccination/ic_girl_community.jpg"
                                                                                }
                    
                                                                        alt="userprofile pic" />
                                                                    </div>
                                                                    <div className="gr_tr_select_child">
                                                                        <span className="gr_tr_child_name">{this.state.selectedChild?.ChildName || ""}</span>
                                                                        <span className="gr_tr_childage R14_42">{this.state.selectedChild?.Age} old {this.state.selectedChild?.Gender} </span>
                                                                    </div>
                                                                </div>

                                                                <div className="vcc_sel_down_arrow">
                                                                    <img src="https://cdn.cdnparenting.com/brainbees/community/vaccination/Arrowchild_select.svg" alt="dropdown arrow" ></img>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        
                                                    </div>
                                                </div>
                                                {/* Child Select End */}

                                                <div className="vaccinStatus" >

                                                    {/* OVERDUE */}
                                                    <div className="vaccin_overdue">
                                                        <div className="dayCount" onClick={() => this.showVaccineStatus("overdue")}>
                                                            <span className="overdueCount">{this.state.overdueCnt}</span>
                                                        </div>

                                                        <div className={`vaccinStatusText ${this.state.activeStatus === "overdue" ? "activeOverdue" : "R15_61" }`}>
                                                            Overdue
                                                            <div className={`${ this.state.activeStatus === "overdue" ? "activeOText" : "text_bottom" }`}></div>
                                                        </div>
                                                    </div>

                                                    {/* UPCOMMING */}
                                                    <div className="vaccin_upcomming">
                                                        <div className="dayCount" onClick={() => this.showVaccineStatus("upcoming")}>
                                                            <span className="upcommingCount">{this.state.upcomingsCnt}</span>
                                                        </div>

                                                        <div className={`vaccinStatusText ${this.state.activeStatus === "upcoming" ? "activeUpcomming" : "R15_61"}`}>
                                                            Upcoming
                                                            <div className={`${ this.state.activeStatus === "upcoming" ? "activeUText" : "text_bottom" }`}></div>
                                                        </div>
                                                    </div>

                                                    {/* DONE */}
                                                    <div className="vaccin_done">
                                                        <div className="dayCount" onClick={() => this.showVaccineStatus("given")}>
                                                            <span className="doneCount">{this.state.givenCnt}</span>
                                                        </div>

                                                        <div className={`vaccinStatusText ${this.state.activeStatus === "given" ? "activeDone" : "R15_61" }`}>
                                                            Done
                                                            <div className={`${this.state.activeStatus === "given" ? "activeDText" : "text_bottom"}`}></div>
                                                        </div>
                                                    </div>

                                                </div>
                                        
                                            </div>
                                        </div>
                                        {this.state.isDesktop &&
                                        <>
                                            <div className="advertisement_wrapper">
                                                <div className="advertisementRight_vcc">
                                                    <div style={{textAlign: "center",padding: "15px 0px 11px",fontSize: "12px",}}>ADVERTISEMENT</div>
                                                    <div className="rightside">
                                                        <div id="c21ba44c-f89a-460f-bbb9-bc29c66647af"
                                                            className="_ap_apex_ad"
                                                            style={{ width: "336px", height: "280px" }}
                                                        >
                                                            {/* <img src="https://cdn.cdnparenting.com/brainbees/community/vaccination/912117783681748523%201.png"></img> */}
                                                        </div>
                                                    </div> 
                                                </div>
                                            </div>
                                        </>
                                        }
                                    </div>

                                    
                                </div>

                                <ChildListOverlay eleRef={this} />
                                {this.state.showFilter &&
                                    <FilterOverlay  eleRef={this} />
                                }
                                
                                    
                            </>
                            )}

                        </div>
                    </div>
                </div>

            
                {
                    this.state.isDesktop ? (
                        <div className="curve_img">
                        <img
                            src="https://cdn.cdnparenting.com/brainbees/community/vaccination/curve_img_desktop.png"
                            alt=""
                        />
                        </div>
                    ) : (
                        this.state.isLoggedin && this.state.childlist?.length > 0 && (
                        <div className="curve_img_mob">
                            <img src="https://cdn.cdnparenting.com/brainbees/community/vaccination/curve_img_mob2.png" alt="" />
                        </div>
                        )
                    )
                    }
         
                {(this.state.isLoggedin && this.state.childlist?.length > 0) && (
                    <div className="maincontainer2" ref={this.mainContainerRef} >
                        {stages.length > 0 ? (


                        <div ref={this.ageSliderDivRef} className={`age_group ${this.state.isDesktop ? (stages.length < 7 ? "lessThanSeven" : "") : (stages.length < 4 ? "lessThanFour" : "")}`} >

                            {stages && stages.map((stage, index) => {

                                let topParts = [];
                                let bottomText = "";

                                if (stage.stagetitle === "Birth") {
                                    topParts = ["At"];
                                    bottomText = "Birth";
                                } else {
                                    const parts = stage.stagetitle.split(" ");
                                    const timeUnits = [
                                        "week",
                                        "weeks",
                                        "month",
                                        "months",
                                        "year",
                                        "years"
                                    ];

                                    const unitIndex = parts.findIndex(p =>
                                        timeUnits.includes(p.toLowerCase())
                                    );

                                    if (unitIndex !== -1) {
                                        topParts = parts.slice(0, unitIndex);
                                        bottomText = parts.slice(unitIndex).join(" ");
                                    } else {
                                        topParts = [parts[0]];
                                        bottomText = parts.slice(1).join(" ");
                                    }
                                }

                                // const isActive = realstage == stage.stageid;

                                const isActive = this.state.ageid ? Number(this.state.ageid) === Number(stage.stageid) : realstage == stage.stageid;

                                return (
                                    <div key={stage.stageid || index} className="age-slide" >
                                        <div className={`${ stage.stagetitle } ageTab age_${stage.stageid} ${ isActive ? "activeage" : ""}`}
                                            onMouseDown={(e) => e.preventDefault()}
                                            onClick={() => this.changeAgeid(stage.stageid)}
                                        >
                                            {isActive && (
                                                <img className="activeage_img" src="https://cdn.cdnparenting.com/brainbees/community/vaccination/active_agetab.png" alt=""                                                 />
                                            )}

                                            {(this.state.activeStatus &&
                                                this.state.activeStatus !== "all") &&
                                                (() => {
                                                    const count =
                                                        this.state.activeStatus === "overdue"
                                                            ? stage.overDueCount
                                                            : this.state.activeStatus === "upcoming"
                                                            ? stage.upCommingCount
                                                            : stage.givenCount;

                                                    return count > 0 ? (
                                                        <div className={`count_${this.state.activeStatus} R12_FF`} >
                                                            {count}
                                                        </div>
                                                    ) : null;
                                                })()
                                            }

                                            <span className={`topText ${ isActive ? "activText" : ""}`}>
                                                {topParts.map((word, i) => (
                                                    <React.Fragment key={i}>
                                                        {word.toLowerCase() === "to" ? (
                                                            <span className="to_text">
                                                                {word}
                                                            </span>
                                                        ) : (
                                                            word
                                                        )}

                                                        {i !== topParts.length - 1 && " "}
                                                    </React.Fragment>
                                                ))}
                                            </span>

                                            <span className={`bottomText ${isActive ? "activText" : ""}`} >
                                                {bottomText}
                                            </span>

                                            {isActive && ( 
                                                <div className="activeageid"></div>
                                            )}

                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        ):(

                        <div className="nodata">
                            <span> No vaccines given to {this.state.selectedChild?.ChildName} yet</span>
                        </div>

                        ) }
                    </div>
                )}
                {(this.state.isLoggedin && this.state.childlist?.length > 0) && (
                    <div className={`maincontainer_vaccine ${this.state.isEmpty ? 'no_vcc_details_data':'' }`}>
                        <div className="vaccine_Container">
                            {(this.state.vaccineData && this.state.vaccineData.length > 0) && !this.state.isEmpty ? (
                                this.state.vaccineData.map((vaccine, index) => {

                                    const isExpanded = this.state.expandedIndex === index;

                                    return (
                                        <div className="vaccine_details"  key={index} ref={(el) => (this.descriptionRefs[index] = el)}  data-givenon={vaccine.givenOn}>
                                            <div className="vaccine_data" >
                                                <div className={`vcc_data_grp1 ${isExpanded ? 'load_more_class':''} `}>
                                                   <div className={`vcc_status_div ${this.state.activeStatus || ""}`} >
                                                        <span className={`vcc_status vcc_${vaccine.vaccineStatus.toLowerCase()}`}>
                                                            {vaccine.vaccineStatus}
                                                        </span>
                                                    </div>
                                                    <div className="vaccine_name">
                                                        {/* <img src="https://cdn.cdnparenting.com/brainbees/community/vaccination/vaccine.png" /> */}

                                                        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g clip-path="url(#clip0_1817_121)">
                                                            <path d="M5.86419 18.9361C6.04576 18.7546 6.29181 18.6523 6.54851 18.6523C6.80537 18.6523 7.0519 18.7552 7.23352 18.9368L8.37428 20.0776L19.7971 8.65474C20.1708 8.32382 20.634 8.11086 21.1284 8.04293C21.6681 7.99034 22.2128 8.07023 22.7146 8.27564C22.9686 8.37963 23.2078 8.51466 23.4272 8.67615L24.4354 7.66797C24.6148 7.51079 24.8242 7.39143 25.0507 7.31648C25.2772 7.24153 25.5165 7.21239 25.7543 7.23155C25.9921 7.25071 26.2236 7.31747 26.4352 7.42766C26.547 7.48591 26.6514 7.55689 26.748 7.63689L31.0645 3.32036C31.1856 3.19935 31.3498 3.1305 31.521 3.13047C31.6922 3.13047 31.8564 3.19932 31.9774 3.32036C32.0983 3.44135 32.1666 3.60509 32.1666 3.77612C32.1666 3.94729 32.0985 4.11221 31.9774 4.23325L27.6616 8.54909L27.8936 8.78111C28.1913 9.10815 28.3722 9.52687 28.4046 9.97159C28.4113 10.2033 28.3691 10.4342 28.2803 10.6483C28.1916 10.8622 28.0586 11.055 27.8902 11.2139L26.8723 12.2317C27.1593 12.7037 27.3445 13.2359 27.4082 13.7937C27.4171 14.1245 27.3566 14.4537 27.2307 14.7597C27.1047 15.0659 26.9162 15.3417 26.6769 15.5704L15.272 26.9753L16.283 27.9862C16.3728 28.0762 16.445 28.1829 16.4936 28.3004C16.5421 28.4178 16.5668 28.5436 16.5668 28.6706C16.5667 28.7977 16.5416 28.924 16.4929 29.0414C16.4442 29.1588 16.3722 29.2657 16.2823 29.3556C16.1009 29.5368 15.8551 29.6385 15.5987 29.6387C15.342 29.6388 15.0952 29.5369 14.9136 29.3556L12.3697 26.8116C12.3433 26.8382 12.3189 26.8666 12.291 26.8917L12.2931 26.8938L9.20569 29.9812L10.1082 30.8837C10.1982 30.9737 10.2702 31.0804 10.3188 31.1979C10.3674 31.3152 10.392 31.4411 10.392 31.568C10.392 31.6952 10.3668 31.8214 10.3181 31.9389C10.2694 32.0563 10.1982 32.1639 10.1082 32.2537C9.92668 32.4351 9.67985 32.5369 9.42321 32.5369C9.16658 32.5368 8.92036 32.4345 8.73889 32.253L3.15316 26.6673C2.9717 26.4858 2.86945 26.2397 2.86935 25.983C2.86935 25.7261 2.97153 25.4789 3.15316 25.2973C3.33476 25.1158 3.58141 25.0142 3.83817 25.0142C4.09493 25.0142 4.3409 25.1165 4.52249 25.298L5.57831 26.3538L8.67605 23.2561C8.69996 23.2337 8.72658 23.2146 8.75132 23.1932L5.86419 20.3061C5.68261 20.1245 5.57973 19.8779 5.57969 19.6211C5.57969 19.3643 5.68257 19.1177 5.86419 18.9361ZM13.9034 25.6067L25.3082 14.2018C25.3599 14.1601 25.4012 14.107 25.4298 14.0471C25.4583 13.9871 25.4735 13.9209 25.4733 13.8545C25.3803 13.4366 25.1549 13.06 24.8311 12.78L22.638 10.5869C22.4955 10.4084 22.3187 10.26 22.118 10.1511C21.9171 10.0423 21.6956 9.97492 21.4682 9.95294C21.3444 9.95928 21.2247 9.99988 21.1222 10.0696L19.5906 11.6012L21.3121 13.3227C21.4021 13.4126 21.474 13.5195 21.5227 13.6369C21.5713 13.7542 21.5959 13.8801 21.5959 14.0071C21.5959 14.1343 21.5714 14.2611 21.5227 14.3786C21.474 14.4961 21.4021 14.6029 21.3121 14.6928C21.2222 14.7827 21.1148 14.854 20.9972 14.9027C20.8799 14.9512 20.7541 14.9759 20.6271 14.9759C20.4999 14.9758 20.3738 14.9507 20.2563 14.902C20.139 14.8533 20.0326 14.7819 19.9428 14.6921L18.2213 12.9706L16.1366 15.0553L17.8581 16.7768C17.9481 16.8667 18.02 16.9735 18.0687 17.091C18.1173 17.2083 18.1418 17.3341 18.1419 17.4611C18.1419 17.5884 18.1174 17.7151 18.0687 17.8326C18.02 17.9501 17.9481 18.0569 17.8581 18.1468C17.7682 18.2366 17.6613 18.3074 17.5439 18.3561C17.4264 18.4047 17.3003 18.43 17.1731 18.4299C17.0459 18.4299 16.9197 18.4048 16.8023 18.3561C16.685 18.3073 16.5785 18.236 16.4887 18.1461L14.7672 16.4246L12.6832 18.5087L14.4047 20.2302C14.4947 20.3201 14.5666 20.4269 14.6153 20.5444C14.6639 20.6617 14.6885 20.7875 14.6885 20.9145C14.6885 21.0417 14.6641 21.1684 14.6153 21.286C14.5666 21.4035 14.4947 21.5103 14.4047 21.6002C14.3148 21.69 14.2079 21.7608 14.0905 21.8094C13.973 21.8581 13.8469 21.8833 13.7197 21.8833C13.5926 21.8832 13.4663 21.8581 13.3489 21.8094C13.2316 21.7607 13.1251 21.6893 13.0354 21.5995L11.3139 19.878L9.7443 21.4476L13.9034 25.6067ZM7.83567 28.6112L10.923 25.5238C10.9494 25.4978 10.9748 25.4701 10.9976 25.4409L10.1338 24.5771C10.0926 24.5969 10.0534 24.6216 10.0178 24.6503L6.94626 27.7218L7.83567 28.6112ZM25.5755 10.7885L26.3689 9.99507L25.6086 9.23479L24.8152 10.0282C25.1238 10.3367 25.3694 10.5829 25.5755 10.7885Z" fill="#616161"/>
                                                            </g>
                                                            <defs>
                                                            <clipPath id="clip0_1817_121">
                                                            <rect width="36" height="36" fill="#757575"/>
                                                            </clipPath>
                                                            </defs>
                                                        </svg>
                                                        <div className="vcc_data">
                                                            <span className="vcc_title M18_21">
                                                                {vaccine.vaccinetitle}
                                                            </span>
                                                            <span className="vcc_duedate R15_61">
                                                                Due on {vaccine.dueon}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="vcc_data_grp2">
                                                    {vaccine.vaccineStatus == "Given" ? (
                                                        <div className="mark_given " onClick={()=>this.openStatusPopup(vaccine.vaccineid,index)} >
                                                            <img src="https://cdn.cdnparenting.com/brainbees/community/vaccination/right_816.png"></img>
                                                            <span className="M15_FF">View Details</span>
                                                            </div>
                                                    ):(
                                                        <div className="markdone_box" onClick={()=>this.openMarkdonePopup(vaccine.vaccineid)} >
                                                            <span className="mark_done">Mark Done</span>
                                                        </div>
                                                    )}
                                                    <span
                                                        className="learn_more"
                                                        onClick={() =>
                                                            this.state.isDesktop
                                                            ? this.showVaccineDetails(index, vaccine.vaccineid)
                                                            : this.openVaccineDetailsPopup(index, vaccine.vaccineid)
                                                        }
                                                        >
                                                        Learn More
                                                    </span>
                                                    
                                                </div>
                                            </div>

                                            {isExpanded &&
                                            <div className="load_more" >
                                                <div ref={this.noMediaRef} className={`vaccineDescription ${hasMedia ? "has-media" : "no-media"} `}>
                                                    <p className="vaccineDescription_text" >
                                                        {/* {vaccine.vaccinedesc} */}
                                                        {this.state.expandedDescIndex === index
                                                            ? vaccine.vaccinedesc
                                                            : vaccine.vaccinedesc.slice(0, 250)
                                                        }

                                                        {vaccine.vaccinedesc.length > 250 && (
                                                            <div 
                                                                className="read_more_btn" 
                                                                onClick={() => this.toggleReadMore(index)}
                                                            >
                                                                {this.state.expandedDescIndex === index ? "Read Less" : "Read More"}
                                                            </div>
                                                        )}
                                                    </p>
                                                    {articles && articles.length > 0 && (
                                                        <div className="reletedArticlesDiv">
                                                            <div className="reletedArticlestitle">
                                                                <span>Related Articles </span>
                                                            </div>
                                                            <div className="reletedArticles">

                                                                <div className="article_list">
                                                                    <Swiper {...params} observer={true} observeParents={true} resizeObserver={true} rebuildOnUpdate={true} shouldSwiperUpdate={true} >
                                                                        {articles.map(article => (
                                                                        <div key={article.id} className="vccarticle">
                                                                            <a href={article.article_url} target="_blank" rel="noopener noreferrer" >
                                                                            <div className="vccarticle_info" data-artname={article.article_title} data-artid={article.id} >
                                                                                <div className="vccarticle_images">
                                                                                    <img src={article.article_image} alt={article.article_title} />
                                                                                </div>

                                                                                <div className="vccarticle_title">
                                                                                    <span>{article.article_title}</span>
                                                                                </div>
                                                                            </div>
                                                                            </a>
                                                                        </div>
                                                                        ))}
                                                                    </Swiper>
                                                                    
                                                                </div>


                                                            </div>
                                                        </div>
                                                    )}
                                                    {videos && videos.length > 0 && (
                                                        <div className="reletedVideoDiv">
                                                            <div className="reletedVideotitle">
                                                                <span>Videos</span>
                                                            </div>
                                                            <div className="reletedVideo">
                                                                <div className="vccVideo_list">
                                                                {/* const playersRef = useRef({}); */}
                                                                <Swiper {...videoParams} observer={true} observeParents={true} resizeObserver={true} >
                                                                    {videos.map(video => (
                                                                        // <div key={video.id} className="vccvideo-component">
                                                                        <div className="vccvideo-component">
                                                                            <div className="content-div-box-artical vcc_content-div-box-artical">
                                                                                <div className="content-div_view_artical div_view_video">
                                                                                    <YouTube
                                                                                        videoId={new URL(video.video_url).searchParams.get("v")}
                                                                                        onReady={(event) => {
                                                                                            this.playersRef[video.id] = event.target;
                                                                                        }}
                                                                                        onPlay={() => {
                                                                                            Object.keys(this.playersRef).forEach(id => {
                                                                                                if (parseInt(id) !== video.id) {
                                                                                                    try {
                                                                                                        this.playersRef[id].pauseVideo();
                                                                                                    } catch (e) {}
                                                                                                }
                                                                                            });
                                                                                        }}
                                                                                        opts={{
                                                                                            width: "336",
                                                                                            height: "200",
                                                                                            playerVars: {
                                                                                                playsinline: 1,
                                                                                                rel: 0
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </Swiper>
                                                                
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}

                                                </div>
                                            </div>
                                            }
                                        </div>
                                    );
                                })
                            ):(
                                <div className="no_vaccinedata">
                                    <span>No vaccines given to {this.state.selectedChild?.ChildName} yet.</span>
                                </div>
                            )}
                        </div>
                    </div>
                )}

                <div className={`${(this.state.isLoggedin==true && this.state.childlist.length > 0) ?'faq_container':'faq_container_nonlog'}`}>
                    <div className="faq_mobdiv">
                        <span className="R14_9e" onClick={()=>this.openFaq()} >FAQs</span>
                        <span className="R14_9e" onClick={()=>this.openDisclaimer()}>Disclaimer</span>
                        <span className="R14_9e" onClick={()=>this.openFeedback()} >Feedback</span>
                    </div>
                </div>
                
                {this.state.showMarkdone &&
                    <MarkDonePopup eleRef={this} />
                }
                {
                this.state.showStatus && 
                    <ShowStatusPopup eleRef={this} />
                }

                {this.state.openVaccinePopup &&
                    <ShowVaccineDetailsPopup eleRef={this} />
                }

                {/* {this.state.showFaqPopup && */}
                    <FaqPopup eleRef={this} />
                {/* } */}

                {/* {this.state.showDisclaimerPopup && */}
                    <DisclaimerPopup eleRef={this} />
                {/* } */}
                {this.state.showFeedbackPopup && 
                    <FeedbackPopup eleRef={this} />
                }

            
            </>
        )

    }
}
export default withContext(VaccinationTracker);